import React from 'react';
import { Box, Card, CardActionArea, Typography } from '@mui/material';

/*
 * The empty state. Clicking a card FILLS the composer rather than sending —
 * the phrasing is the part worth adjusting, and half these prompts end with a
 * blank the user has to complete anyway.
 */
const SkillCards = ({ skills, onPick, brandName }) => (
  <Box sx={{ maxWidth: 760, mx: 'auto', py: 6 }}>
    <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
      What do you want to know?
    </Typography>
    <Typography sx={{ color: 'text.secondary', mb: 4, fontSize: 15 }}>
      {brandName
        ? `Answers come from live platform data, scoped to ${brandName}.`
        : 'Answers come from live platform data.'}
    </Typography>

    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
        gap: 1.5,
      }}
    >
      {skills.map((skill) => (
        <Card key={skill.id} variant="outlined" sx={{ borderRadius: 2 }}>
          <CardActionArea onClick={() => onPick(skill)} sx={{ p: 2, height: '100%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: 14.5, mb: 0.5 }}>
              {skill.title}
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: 13.5, lineHeight: 1.5 }}>
              {skill.description}
            </Typography>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  </Box>
);

export default SkillCards;
